export const REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE = 'REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE'
export const REQUEST_SPONSOR_LIST = 'REQUEST_SPONSOR_LIST'
export const REQUEST_CAMPAIGN_SPONSOR_LIST = 'REQUEST_CAMPAIGN_SPONSOR_LIST'
export const REQUEST_SPONSOR = 'REQUEST_SPONSOR'